<template lang="pug">
  .wrapper-timesheet(:class="{'prevent-double-scroll': sheetParams.type !== 'employee'}")
    .header
      HeaderTimesheet(@focusSomas="focusSomas")

    .sheet
      Sheet(
      :journeys="sheetParams.journeys",
      :type="sheetParams.type",
      :startDate="sheetParams.startDate",
      :endDate="sheetParams.endDate",
      @onLineEmit="onLineEmit"
      )

    template(v-if="isSheetLockable")
      LockerHistory

    template(v-if="sheetParams.type ==='employee'")

      div(:class="showWHB ? 'sumtimes-whb' : 'sumtimes'")

        Accordion(:startOpen="false")
          template(slot="heading")
            span.fs-19(style="text-align: center;") apontamentos do mês

          template
            SumTimes(ref="sumtimes", @focusOut="focusLastPt")

        Accordion(:startOpen="false" v-if="showWHB && employeeHasAlreadyWorked")
          template(slot="heading")
            span.fs-19(style="text-align: center;") acumulado do banco de horas

          template
            SumsWHB(
              :sumWhb="sumWhb"
              :loadingSumWhb="loadingSumWhb"
            )

</template>

<script>
import HeaderTimesheet from './Header/HeaderTimesheet.vue'
import LockerHistory from 'src/components/Sheets/Timesheet/LockerHistory'
import Sheet from '../Sheet/Sheet.vue'
import SumsWHB from './Sums/Whb/SumsWHB'
import moment from 'moment'
import { mapGetters, mapState } from 'vuex'
import SumTimes from './Sums/SumTimes'
import { changeFocusToPt } from '../Sheet/state/helpers.js'
import { setAmplitudeEvent } from 'src/amplitudeUtils'

export default {
  props: {
    type: { type: String },
    id: {},
    startDate: {},
    endDate: {}
  },
  mounted () {
    setAmplitudeEvent('lista folhas de ponto', {})
  },
  data () {
    return {}
  },
  async created () {
    // Trigger calc sumtimes when something is being updated
    // We dont call for djs because it already triggers calc tms and lines again

    this.$store.subscribeAction((action) => {
      if (['sheet/updateLine', 'sheet/updateMultipleLines', 'sheet/recalcLines'].includes(action.type)) {
        // prevent useless commit
        if (!this.$store.state.timesheet.loadingSumTimes || !this.$store.state.timesheet.loadingSumWhb) {
          this.$store.commit('timesheet/loadingSumTimes', true)
          this.$store.commit('timesheet/loadingSumWhb', true)
        }
      }
    })

    this.$store.subscribe((mutation) => {
      if (['sheet/updateLine', 'sheet/updateMultipleLines'].includes(mutation.type)) {
        this.$store.dispatch('timesheet/getSumTimes')
        this.$store.dispatch('timesheet/getSumWhb')
      }
    })

    await this.buildTimesheet()

    window.addEventListener('beforeunload', this.beforeCloseTab)
  },
  computed: {
    ...mapState('timesheet', ['journeys', 'sumWhb', 'loadingSumWhb', 'sumTimes', 'loadingSumTimes']),
    ...mapGetters('timesheet', ['buildingSheet', 'showWHB', 'loading']),
    ...mapState('sheet', ['lines']),
    ...mapGetters('timesheet/header', ['currentQueueEmployee']),
    ...mapState('timesheet/header', ['queueCurrentIndex', 'queueEmployees']),
    ...mapState('sheet/lineActions', ['numeroLinhaAbrirInfo']),
    sheetParams () {
      return {
        journeys: this.journeys,
        type: this.$store.state.timesheet.header.type || this.type,
        startDate: this.$store.state.timesheet.header.startDate,
        endDate: this.$store.state.timesheet.header.endDate
      }
    },
    isSheetLockable () {
      return this.type === 'employee' &&
        this.$store.state.userInfo.compMan.canLockFolha &&
        this.$store.getters['timesheet/sheet'].lines &&
        this.$store.getters['timesheet/sheet'].lines[0]
    },
    employeeHasAlreadyWorked () {
      if (!this.currentQueueEmployee || !this.currentQueueEmployee.firstWorkDay) {
        return true
      }
      const diaDeFimDaFolha = this.sheetParams.endDate.getTime()
      const primeiroDiaDeTrabalho = Date.parse(this.currentQueueEmployee.firstWorkDay)
      return diaDeFimDaFolha >= primeiroDiaDeTrabalho
    }
  },
  watch: {
    $route (to, _from) {
      if (to.name !== 'timesheet') {
        // sometimes it doesnt get called :/
        console.log('destruindo tela')
        this.$destroy()
      }
    },
    lines: {
      deep: true,
      handler (value) {
        if (value && value.length) {
          // parece que as linhas foram carregadas
          if (this.numeroLinhaAbrirInfo != null && this.numeroLinhaAbrirInfo >= 0) {
            this.$store.commit('sheet/lineActions/activateLineActions', {
              rowNumber: this.numeroLinhaAbrirInfo,
              type: 'lineInfo'
            })
          }
        }
      }
    }
  },
  methods: {
    focusSomas () {
      this.$refs.sumtimes.focus()
    },
    focusLastPt () {
      changeFocusToPt([this.$store.getters['timesheet/sheet'].lines.length - 1, 0], null, true)
    },
    onLineEmit ({ type, ...args }) {
      if (type === 'goEmployeeSheet') {
        const {employee} = args

        // We set loading here just to avoid rerender all SheetComponent
        // when we change the header type, it will freeze the browser for a moment
        this.$store.commit('sheet/loading', {lines: true})

        this.$store.commit('timesheet/header/employees', {selected: [employee]})
        this.$store.commit('timesheet/header/queueEmployees', [employee])
        this.$store.commit('timesheet/header/type', 'employee')
        this.$store.dispatch('timesheet/header/calcPeriod', {closingSheet: true})
      }
    },
    async buildTimesheet () {
      const startDate = moment(this.startDate, 'YYYY-MM-DD').toDate()
      const endDate = moment(this.endDate, 'YYYY-MM-DD')

      // the type queue is used to alow other screens go to timesheet with a queue of employees
      if (this.type !== 'queue') {
        this.$store.commit('timesheet/header/resetState')
        this.$store.commit('sheet/resetState')
      }

      // we net get info of who is selected, as name, both APIs return a list with one element
      if (this.type === 'work-place') {
        const result = await this.$API.company.get({ id: this.id })
        this.$store.commit('timesheet/header/companies', { selected: result.data.success })
      } else if (this.type === 'user-group') {
        const result = await this.$API.userGroup.get({ id: this.id })
        this.$store.commit('timesheet/header/userGroups', { selected: result.data.success })
      } else if (this.type === 'employee') {
        const result = await this.$API.employee.get({ id: this.id, fired: 'all', active: false })
        this.$store.commit('timesheet/header/queueEmployees', result.data.success)

        // update selected and loaded
        this.$store.commit('timesheet/header/employees', {
          selected: result.data.success
        })
        this.$store.commit('timesheet/header/companies', {
          selected: result.data.success[0].company
        })
      }

      this.$store.commit('timesheet/header/setOptions', {
        type: this.type === 'queue' ? 'employee' : this.type,
        startDate,
        id: this.id,
        endDate: endDate.isValid() ? endDate : startDate
      })

      this.$store.dispatch('timesheet/header/calcPeriod', {})
    },
    beforeCloseTab (event) {
      // Checa se ainda há ações nas queues antes de fechar
      // A pessoa pode estar adicionando/editando/deletando algum ponto
      // e ação ainda não foi realizada
      const someQueueIsNotEmpty = this.$store.getters['sheet/promiseQueueIsNotEmpty']

      if (someQueueIsNotEmpty) {
        event.preventDefault()
        event.returnValue = ''
      }
    }
  },
  beforeDestroy () {
    window.removeEventListener('beforeunload', this.beforeCloseTab)
  },
  beforeRouteLeave (to, from, next) {
    const someQueueIsNotEmpty = this.$store.getters['sheet/promiseQueueIsNotEmpty']
    if (someQueueIsNotEmpty) {
      const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
      if (!answer) {
        next(false)
      }
    }

    this.$store.commit('sheet/clearAllPromiseQueues')
    next()
  },
  provide: { changeFocusToPt },
  components: { HeaderTimesheet, Sheet, SumTimes, SumsWHB, LockerHistory }
}
</script>

<style lang="scss">
.wrapper-timesheet {
  /* BE CAREFULL IF NEED TO CHANGE THIS STYELES.
  IT ENSURES TO NOT CREATE DOUBLE SCROLL IF WE ARE IN COMPANIES OR GROUPS VIEW
  WITH DOUBLE SCROLL I MEAN: SCROLL OF RECYCLELIST AND WINDOWS IT'S SELF
  */
  justify-content: center;
  display: grid;
  grid-template-rows: minmax(0, min-content) minmax(0, auto) min-content min-content;
  grid-template-columns: 1fr;

  &.prevent-double-scroll {
    height: 100%;
    overflow-y: hidden
  }

  .header {
    grid-row: 1;
    height: 100%;
    max-height: 100%;
    z-index: 2;
  }
  .sheet {
    width: 100%;
    height: 100%;
    text-align: center;
    grid-row: 2;
    padding-bottom: 10px;
    z-index: 1;
  }
  .sumtimes {
    grid-row: 3;
    padding-top: 20px;
  }

  .sumtimes-whb {
    grid-row: 4;
    display: grid;
    grid-column-gap: 20px;
    grid-row-gap: 20px;
  }
  .sumtimes-whb, .sumtimes {
    width: 100%;
    margin-bottom: 40px;
  }

  .format-smal-bold {
    font-size: 12px;
  }
  .format-smal-bold > span {
    color: grey;
  }
}

</style>
